import { render, staticRenderFns } from "./ModalClientNotification.vue?vue&type=template&id=1a9eb404&scoped=true"
import script from "./ModalClientNotification.vue?vue&type=script&lang=js"
export * from "./ModalClientNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9eb404",
  null
  
)

export default component.exports